const isAdmin = !! ( ( window.wp && window.wp.acf ) || document.querySelector( 'body' ).classList.contains( 'wp-admin' ) );

export default isAdmin;
